import { render, staticRenderFns } from "./resetPass.vue?vue&type=template&id=49f3778d&scoped=true"
import script from "./resetPass.vue?vue&type=script&lang=js"
export * from "./resetPass.vue?vue&type=script&lang=js"
import style0 from "./resetPass.vue?vue&type=style&index=0&id=49f3778d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f3778d",
  null
  
)

export default component.exports